// Reusable hero section component for area profiles
import React from 'react';

const AreaProfileHero = ({ areaData }) => {
  if (!areaData) return null;

  return (
    <div className="relative h-[400px] overflow-hidden mb-12 rounded-lg">
      {areaData.heroImage?.asset?.url ? (
        <img
          src={areaData.heroImage.asset.url}
          alt={areaData.heroImage.alt || areaData.title}
          className="w-full h-full object-cover"
        />
      ) : (
        <div className="w-full h-full flex items-center justify-center bg-gray-800">
          <h1 className="text-5xl font-bold text-white">
            {areaData.title}
          </h1>
        </div>
      )}
      <div className="absolute inset-0 bg-black/40" />
      <div className="absolute bottom-0 left-0 right-0 p-8 text-white">
        <div className="max-w-6xl mx-auto">
          <h1 className="text-5xl font-bold mb-4">{areaData.title}</h1>
          <p className="text-xl max-w-3xl">{areaData.oneLiner}</p>
        </div>
      </div>
    </div>
  );
};

export default AreaProfileHero;